import { cn } from '../../lib/cn';

export default function LoadingState({ label = 'Loading…', className }: { label?: string; className?: string }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 text-muted text-[13.5px] py-10', className)} role="status">
      <span className="hs-spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
